import { mapGetters, mapActions } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import { EventBus } from '@/helpers/event-bus';

export const ComplexFieldMixin = {
    data() {
        return {
            changesMade: false
        };
    },
    methods: {
        ...mapActions([
            'addDifferChangedField',
            'addDifferInvalidField',
            'deleteDifferInvalidField'
        ]),
        async componentDifferInit() {
            this.changesMade = false; // this is important when hiding and showing this component
            await this.init();
            await this.componentDifferValidate();
        },
        async componentDifferChange() {
            if (this.changesMade === false) {
                this.changesMade = true;
                await this.addDifferChangedField({
                    value: this.getProp(this.dataSource),
                    source: this.dataSource,
                    route: this.openedRoute
                });
            }
        },
        async componentDifferValidate(revalidate = false) {
            let valid = this.validate(this.getProp(this.dataSource));
            // if valid is null, we normally ignore it
            // if we revalidate a field, we treat it as true
            if (revalidate === true && valid === null) {
                valid = true;
            }
            if (valid === false) {
                await this.addDifferInvalidField({
                    source: this.dataSource,
                    route: this.openedRoute
                });
            } else if (valid === true) {
                await this.deleteDifferInvalidField({
                    source: this.dataSource,
                    route: this.openedRoute
                });
            }
            if (this.revalidateSource !== undefined && revalidate === false) {
                EventBus.$emit('revalidate', this.revalidateSource);
            }
        }
    },
    computed: {
        ...mapGetters(['getProp', 'getCurrentRouteFullPath'])
    },
    mixins: [OpenedRouteMixin],
    created() {
        this.componentDifferInit();
    },
    mounted() {
        /* revalidation logic for dependend fields */
        if (this.revalidateTarget !== undefined) {
            EventBus.$on('revalidate', (revalidateSource) => {
                if (this.revalidateTarget === revalidateSource) {
                    this.componentDifferValidate(true);
                }
            });
        }
    },
    beforeDestroy() {
        if (this.revalidateTarget !== undefined) {
            EventBus.$off('revalidate');
        }
    },
    watch: {
        getCurrentRouteFullPath() {
            this.componentDifferInit();
        }
    },
    props: {
        revalidateSource: String,
        revalidateTarget: String
    }
};
